module.exports = __webpack_public_path__ + "static/media/HI-CAP.d03477da.jpg";